<dialog #_innerModal eclModal size="l" class="login-or-create-account-dialog"
        (modalClose)="modalClose.emit($event)">
    <header eclModalHeader>
        <p class="ecl-u-type-heading-3 ecl-u-type-bold ecl-u-type-align-center ecl-u-mt-none ecl-u-mb-xs" [innerHTML]="'easeportal.create-account-login-modal.HEADER' | translate"></p>
        <p class="ecl-u-mb-l ecl-u-type-paragraph-lead ecl-u-type-align-center ecl-u-mt-none ecl-u-mb-none" [innerHTML]="'easeportal.create-account-login-modal.SUBHEADER' | translate"></p>
    </header>
    <div eclModalBody>
        <ecl-media-container>
            <picture eclMediaContainerPicture>
                <img eclMediaContainerImage src="./assets/images/loginPopup.png" alt="EC Popup Logo">
            </picture>
        </ecl-media-container>

        <ul eclUnorderedList>
            <li eclUnorderedListItem class="ecl-u-mt-s ecl-u-ml-none ecl-u-pl-none ecl-u-pt-none ecl-u-d-flex">
                <ecl-icon icon="check-filled" size="m" class="ecl-u-mr-s check-icon"></ecl-icon>
                {{'easeportal.create-account-login-modal.bullet-1.TEXT' | translate}}
            </li>
            <li eclUnorderedListItem class="ecl-u-mt-s ecl-u-ml-none ecl-u-pl-none ecl-u-pt-none ecl-u-d-flex">
                <ecl-icon icon="check-filled" size="m" class="ecl-u-mr-s check-icon"></ecl-icon>
                {{ 'easeportal.create-account-login-modal.bullet-2.TEXT' | translate}}
            </li>
            <li eclUnorderedListItem class="ecl-u-mt-s ecl-u-ml-none ecl-u-pl-none ecl-u-pt-none ecl-u-d-flex">
                <ecl-icon icon="check-filled" size="m" class="ecl-u-mr-s check-icon"></ecl-icon>
                {{ 'easeportal.create-account-login-modal.bullet-3.TEXT' | translate}}
            </li>
            <li eclUnorderedListItem class="ecl-u-mt-s ecl-u-ml-none ecl-u-pl-none ecl-u-pt-none ecl-u-d-flex">
                <ecl-icon icon="check-filled" size="m" class="ecl-u-mr-s check-icon"></ecl-icon>
                {{ 'easeportal.create-account-login-modal.bullet-4.TEXT' | translate}}
            </li>
        </ul>
    </div>
    <footer eclModalFooter>
        <button eclButton eclModalRole="cancel" [eclModalClose]="'login'" variant="secondary">{{ 'easeportal.create-account-login-modal.button.LOGIN' | translate }}</button>
        <button eclButton eclModalRole="confirm" [eclModalClose]="'createProfile'" variant="primary">{{ 'easeportal.create-account-login-modal.button.CREATE-ACCOUNT' | translate }}</button>
    </footer>
</dialog>
